const initialState = {
    responseBannerList: {},
    responseBanner: {},
    responseUploadBanner: {}
};

const reducer = (state = initialState, action) => {
    const newState = { ...state };
    switch (action.type) {
        case "BANNER_LIST_RESPONSE":
            newState.responseBannerList = action.value
            break;
        case "BANNER_RESPONSE":
            console.log('%c BANNER_RESPONSE / action: ', 'color: #f2dcd3; background: #ab4921', action);
            newState.responseBanner = action.value
            break;
        case "UPLOAD_IMAGE_BACKOFFICE_RESPONSE":
            newState.responseUploadBanner = action.value
            break;
        default:
            return newState;
    }

    return newState;
};

export default reducer;